/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RevenueStatisticsDto } from '../models/RevenueStatisticsDto';
import type { RevenueSummaryDto } from '../models/RevenueSummaryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RevenueStatisticsRestControllerService {
  /**
   * getRevenueStatistics
   * @returns RevenueStatisticsDto OK
   * @throws ApiError
   */
  public static getRevenueStatisticsUsingGet({
    armId,
    classLevelId,
    sessionId,
    month,
    termId,
    year,
  }: {
    /**
     * arm_id
     */
    armId: string;
    /**
     * class_level_id
     */
    classLevelId: string;
    /**
     * session_id
     */
    sessionId: string;
    /**
     * month
     */
    month?:
      | 'APRIL'
      | 'AUGUST'
      | 'DECEMBER'
      | 'FEBRUARY'
      | 'JANUARY'
      | 'JULY'
      | 'JUNE'
      | 'MARCH'
      | 'MAY'
      | 'NOVEMBER'
      | 'OCTOBER'
      | 'SEPTEMBER';
    /**
     * term_id
     */
    termId?: string;
    /**
     * year
     */
    year?: number;
  }): CancelablePromise<RevenueStatisticsDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/revenue-statistics',
      query: {
        arm_id: armId,
        class_level_id: classLevelId,
        month: month,
        session_id: sessionId,
        term_id: termId,
        year: year,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }

  /**
   * getRevenueSummary
   * @returns RevenueSummaryDto OK
   * @throws ApiError
   */
  public static getRevenueSummaryUsingGet({
    month,
    termId,
    year,
  }: {
    /**
     * month
     */
    month?:
      | 'APRIL'
      | 'AUGUST'
      | 'DECEMBER'
      | 'FEBRUARY'
      | 'JANUARY'
      | 'JULY'
      | 'JUNE'
      | 'MARCH'
      | 'MAY'
      | 'NOVEMBER'
      | 'OCTOBER'
      | 'SEPTEMBER';
    /**
     * term-id
     */
    termId?: string;
    /**
     * year
     */
    year?: number;
  }): CancelablePromise<RevenueSummaryDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/revenue-statistics/revenue-summary',
      query: {
        month: month,
        'term-id': termId,
        year: year,
      },
      errors: {
        401: `Unauthorized`,
        403: `Forbidden`,
        404: `Not Found`,
      },
    });
  }
}
